import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login/login.component';
import { authGuard } from './guards/auth.guard';
import { tipsAvailabilityGuard } from './guards/tips-availability.guard';
import { partnerfriedhoefeAvailabilityGuard } from './guards/partnerfriedhoefe-availability.guard';
import { DashComponent } from './components/dash/dash/dash.component';
import { BurialsComponent } from './components/dash/burials/burials.component';
import { CremationComponent } from './components/dash/cremation/cremation.component';
import { PartneredComponent } from './components/dash/partnered/partnered.component';
import { TipsComponent } from './components/dash/tips/tips.component';
import { DocumentsComponent } from './components/documents/documents.component';
import { Dokumente2026Component } from './components/dokumente2026/dokumente2026.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'login/contact', component: LoginComponent },
  {
    path: 'dash',
    component: DashComponent,
    canActivate: [authGuard],
    children: [
      { path: 'burials', component: BurialsComponent },
      { path: 'cremation', component: CremationComponent },
      { path: 'partnered', component: PartneredComponent, canActivate: [partnerfriedhoefeAvailabilityGuard] },
      { path: 'partnered/:link', component: PartneredComponent, canActivate: [partnerfriedhoefeAvailabilityGuard] },
      { path: 'tips', component: TipsComponent, canActivate: [tipsAvailabilityGuard] }
    ]
  },
  { path: 'documents/:id', component: DocumentsComponent, canActivate: [authGuard] },
  { path: 'doks/:guid', component: Dokumente2026Component },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    useHash: navigator.userAgent.toLowerCase().includes('electron')
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
